import { SectionActivityDictionaryItem } from "./hooks/use-snow-plow-analytics/types";

// Регистрация событий изменения адресной строки (переход по разделам).
export const SECTION_ACTIVITY_DICTIONARY_CONFIG: SectionActivityDictionaryItem[] =
  [
    { pathname: "/cards", eventCategory: "dboCards", eventAction: "cardsOpen" },
    {
      pathname: "/deposits",
      eventCategory: "dboDeposits",
      eventAction: "depositsOpen",
    },
    {
      pathname: "/acquiring",
      eventCategory: "dboAcquiring",
      eventAction: "acquiringOpen",
    },
    {
      pathname: "/salary",
      eventCategory: "dboSalary",
      eventAction: "salaryOpen",
    },
    {
      pathname: "/loyalty-program",
      eventCategory: "dboLoyalty",
      eventAction: "loyaltyOpen",
    },
    {
      pathname: "/foreign-activity",
      eventCategory: "dboVed",
      eventAction: "vedOpen",
    },
    {
      pathname: "/main/accounts",
      eventCategory: "dboCheckpayments",
      eventAction: "checkpaymentsOpen",
    },
    {
      pathname: "/counterparties",
      eventCategory: "dboContragents",
      eventAction: "contragentsOpen",
    },
    {
      pathname: "/invoices",
      eventCategory: "dboInvoices",
      eventAction: "invoicesOpen",
    },
    {
      pathname: "/statements",
      eventCategory: "dboStatements",
      eventAction: "statementsOpen",
    },
    {
      pathname: "/payments/templates",
      eventCategory: "dboTemplates",
      eventAction: "templatesOpen",
    },
    {
      pathname: "/payments/templates/new",
      eventCategory: "dboNewTemplate",
      eventAction: "newTemplateOpen",
    },
    {
      pathname: "/analytics",
      eventCategory: "dboAnalytics",
      eventAction: "analyticsOpen",
    },
    {
      pathname: "/tariffs",
      eventCategory: "dboTariffs",
      eventAction: "tariffsOpen",
    },
    {
      pathname: "/references",
      eventCategory: "dboReferences",
      eventAction: "referencesOpen",
    },
    {
      pathname: "/showcase",
      eventCategory: "dboShowcase",
      eventAction: "showcaseOpen",
    },
    {
      pathname: "/ausn",
      eventCategory: "dboAusn",
      eventAction: "ausnOpen",
    },
    {
      pathname: "/payments/new",
      eventCategory: "dboCreate",
      eventAction: "createOpen",
    },
    {
      pathname: "/payments/new/order",
      eventCategory: "dboCreate",
      eventAction: "createNewOrderOpen",
    },
    {
      pathname: "/payments/new/demand",
      eventCategory: "dboCreate",
      eventAction: "createNewDemandOpen",
    },
    {
      pathname: "/payments/new/incasso",
      eventCategory: "dboCreate",
      eventAction: "createNewIncassoOpen",
    },
    {
      pathname: "/payments/import",
      eventCategory: "dboCreate",
      eventAction: "createNewImportOpen",
    },
    {
      pathname: "/sbp/issue-invoice",
      eventCategory: "dboCreate",
      eventAction: "createNewTransferOpen",
    },
    {
      pathname: "/invoices/new",
      eventCategory: "dboCreate",
      eventAction: "createNewInvoiceOpen",
    },
    {
      pathname: "/invoices/details",
      eventCategory: "dboCreate",
      eventAction: "createNewInvoiceConfirmOpen",
    },
    {
      pathname: "/messages",
      eventCategory: "dboMessages",
      eventAction: "messagesOpen",
    },
    {
      pathname: "/help",
      eventCategory: "dboHelp",
      eventAction: "helpOpen",
    },
    {
      pathname: "/main",
      eventCategory: "dboMain",
      eventAction: "mainOpen",
    },
    {
      pathname: "/loans",
      eventCategory: "dboLoans",
      eventAction: "loansOpen",
    },
  ];
